import { Loader } from '@internal/kern-ux';

/**
 * KERN progress indicator. Replaces Backstage's `Progress` (MUI LinearProgress).
 * `srDescription` makes screen readers announce the loading state.
 */
export const KernProgress = () => (
  <Loader visible srDescription="Inhalte werden geladen" />
);
